export default "__VITE_ASSET__51d9f18b__"